var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.75C10.4142 1.75 10.75 2.08579 10.75 2.5V7.5C10.75 7.91421 10.4142 8.25 10 8.25C9.58579 8.25 9.25 7.91421 9.25 7.5V2.5C9.25 2.08579 9.58579 1.75 10 1.75Z",
    fill: "#2F8B21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 6.75C10.4142 6.75 10.75 7.08579 10.75 7.5L10.75 15.6893L15.303 11.1363C15.5959 10.8434 16.0707 10.8434 16.3636 11.1363C16.6565 11.4292 16.6565 11.9041 16.3636 12.197L10.5303 18.0303C10.2374 18.3232 9.76252 18.3232 9.46963 18.0303L3.6363 12.197C3.3434 11.9041 3.3434 11.4292 3.6363 11.1363C3.92919 10.8434 4.40406 10.8434 4.69696 11.1363L9.24996 15.6893L9.24996 7.5C9.24996 7.08579 9.58575 6.75 9.99996 6.75Z",
    fill: "#2F8B21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.3d2dd0fb9ff5afda9bfc61cb455d58fd.svg";
export { ForwardRef as ReactComponent };